import {} from "@apollo/client"
import Button from "@pathwright/ui/src/components/button/Button"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import Text from "@pathwright/ui/src/components/ui/Text"
import GROUP_RESOURCE_PATH_QUERY from "@pathwright/web/src/modules/group/graphql/group-resource-path-query"
import { useQuery } from "@pathwright/web/src/modules/utils/apollo"
import { ConnectStores } from "lib/core/store"
import get from "lodash/get"
import "./MemberListSort.css"

const MemberListSort = ({
  members_ordering,
  members_descending,
  reorderMembers,
  sortMembers,
  offering
}) => {
  const screensize = useScreensizeContext()
  const styles = {
    styleType: "blank",
    color: "#888"
  }

  const groupQuery = useQuery(GROUP_RESOURCE_PATH_QUERY, {
    variables: {
      id: offering && offering.id
    },
    skip: !offering
  })

  const pathHasPoints = get(groupQuery, "data.group.path.points.has_points")

  const orderOptions = [
    { value: "last_activity_time", label: "Activity" },
    { value: "progress", label: "Progress" },
    { value: "created", label: "Joined" }
  ]
  if (pathHasPoints) orderOptions.push({ value: "points", label: "Score" })

  const activeOrder = orderOptions.find(
    (option) => option.value === members_ordering
  )

  return (
    <div className="MemberListSort">
      <DropdownTrigger
        renderDropdown={() => (
          <DropdownMenu closeOnClick>
            <Text.H6>Sort by...</Text.H6>
            {orderOptions.map((item) => (
              <DropdownItem
                key={item.value}
                label={item.label}
                onClick={sortMembers.bind(null, item.value)}
              />
            ))}
          </DropdownMenu>
        )}
      >
        <Button {...styles}>
          {screensize !== "sm" && activeOrder && (
            <span>{activeOrder.label}</span>
          )}
          <Pathicon
            icon={screensize == "sm" ? "settings-horizontal" : "chevron-down"}
          />
        </Button>
      </DropdownTrigger>
      <Button {...styles} onClick={reorderMembers}>
        <Pathicon
          icon="arrow-down"
          style={{ opacity: members_descending ? 1 : 0.3 }}
        />
        <Pathicon
          icon="arrow-up"
          style={{ opacity: members_descending ? 0.3 : 1 }}
        />
      </Button>
    </div>
  )
}

MemberListSort.displayName = "MemberListSort"

const mapStateToProps = (state, ownProps) => {
  const { offering } = state.resourceStore.state
  const { members_ordering, members_descending } = state.memberStore.state
  const { sortMembers } = state.memberStore.action

  const reorderMembers = () => {
    state.memberStore.action.reorderMembers(!members_descending)
  }

  return _.assign(
    {},
    {
      members_ordering,
      members_descending,
      reorderMembers,
      sortMembers,
      offering
    },
    ownProps
  )
}

const stores = [
  { store: "resource", watch: ["offering"] },
  { store: "member", watch: ["members_ordering", "members_descending"] }
]

export default ConnectStores(MemberListSort, stores, {}, mapStateToProps)
